module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  _.each(locals.headings, function(h, i) { 
    ; __append(" <div class=\"list__body__item__heading ")
    ; __append(escapeFn( h.computeClass(locals.model) ))
    ; __append(" align-items-center\" data-heading-index=\"")
    ; __append(escapeFn( i ))
    ; __append("\"> ")
    ;  if (h.subView) { 
    ; __append(" <div id=\"")
    ; __append(escapeFn( locals.computeHeadingId(locals.model.get('id'), h.display) ))
    ; __append("\" class=\"w-100\"></div> ")
    ;  } else { 
    ; __append(" ")
    ;  var item = locals.getTextFromHeading(locals.model, h) 
    ; __append(" ")
    ;  if (item && item.copy) { 
    ; __append(" <span class=\"")
    ; __append(escapeFn( (item && item.class) ? item.class : '' ))
    ; __append(" text-truncate align-middle\"> ")
    ; __append(escapeFn( item.text ))
    ; __append(" </span> <button class=\"copy-key-btn clean-icon-btn text-secondary\" type=\"button\" data-clipboard-text=\"")
    ; __append(escapeFn( item.text ))
    ; __append("\"> <span class=\"fa fa-copy\"></span> </button> ")
    ;  } else { 
    ; __append(" <span class=\"")
    ; __append(escapeFn( (item && item.class) ? item.class : '' ))
    ; __append("\"> ")
    ;  if (item && item.href) { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( item.href ))
    ; __append("\" ")
    ;  if (item.newWindow) { 
    ; __append(" target=\"_blank\" ")
    ;  } 
    ; __append(">")
    ; __append(escapeFn( item.text ))
    ; __append("</a> ")
    ;  } else if (item && item.text !== undefined) { 
    ; __append(" ")
    ; __append(escapeFn( item.text ))
    ; __append(" ")
    ;  } else { 
    ; __append(" ")
    ; __append(escapeFn( item ))
    ; __append(" ")
    ;  } 
    ; __append(" </span> ")
    ;  } 
    ; __append(" ")
    ;  } 
    ; __append(" </div> ")
    ;  });
    ; __append(" ")
    ;  if (locals.showDetails) { 
    ; __append(" <div class=\"d-none d-sm-block col-sm-2 text-center\"> <a href class=\"list__body__item__show_details text-nowrap dropdown-toggle\">Details</a> </div> <div class=\"list__body__item__details col-12\"> <div id=\"")
    ; __append(escapeFn( locals.computeDetailsId(locals.model.get('id')) ))
    ; __append("\"></div> </div> ")
    ;  } 
    ; __append(" ")
    ;  if (locals.subItemsArray.length) { 
    ; __append(" <div id=\"")
    ; __append(escapeFn( locals.uid ))
    ; __append("-subitems\" class=\"col-12 list__body__item__subitems\"></div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/item/template.ejs
// module id = 1239
// module chunks = 1